import React from 'react'
import { globalMenuItemData } from '../../models/axiosModel';
import { ListItemIcon, MenuItem } from '@mui/material';
import globalStyles from "../../assets/styles/global.module.scss";
import { MENU_ITEM_VARIANT_CLASS } from './constant';
import GlobalTooltip from '../utility/tooltip/globalTooltip';
import clsx from 'clsx';

interface GlobalMenuItemProps {
    menuItem: globalMenuItemData,
    index: number,
    handleMenuClose: () => void,
    additionalField?: any
}


const GlobalMenuItem: React.FC<GlobalMenuItemProps> = (props) => {
    const { menuItem, index, handleMenuClose, additionalField } = props;

    const onClickOfMenuItem = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        handleMenuClose(); 
        e.stopPropagation();
        if(menuItem?.onClick){
            menuItem.onClick(additionalField);
        }
    }

    const menuItemContent = (
        <MenuItem
            className={clsx(globalStyles.menuItemStyle, menuItem?.className ? menuItem?.className : globalStyles.secondaryFontSize)}
            key={index}
            onClick={(e) => onClickOfMenuItem(e)}
            disabled={menuItem?.isDisable}
        >
            {menuItem?.content ? (
                menuItem.content
            ) : (
                <>
                    {menuItem?.icon && (
                        <ListItemIcon className={`${MENU_ITEM_VARIANT_CLASS[menuItem?.iconVariant ?? "default"]}`}>
                            {menuItem?.icon}
                        </ListItemIcon>
                    )}
                    <span className={`${MENU_ITEM_VARIANT_CLASS[menuItem?.variant ?? "default"]}`}>
                        {menuItem?.label}
                    </span>
                </>
            )}
        </MenuItem>
    );

    if (menuItem?.tooltip) {
        return (
            <GlobalTooltip
                title={menuItem.tooltip}
                placement={menuItem.tooltipPlacement ?? 'left'}
                arrow={menuItem.tooltipArrow}
            >
                <span>
                    {menuItemContent}
                </span>
            </GlobalTooltip>
        );
    }

    return (
        <>
            {menuItemContent}
        </>
    );
}

export default GlobalMenuItem
